import { useEffect, useRef } from 'react';
import { pushDatalayer } from '~/utilities';

export default function ConversionFlowDatalayer({ flow, activeStepId, datalayerData = {} }) {
    const interestComponentIds = useRef([]);

    useEffect(() => {
        const ids = flow?.form?.components
            ?.filter(component => component.fields?.some(field => field.type === 'interest-checkbox'))
            ?.map(component => component.id) || [];

        if (ids.length > 0) {
            interestComponentIds.current = ids;
        }
    }, [flow?.form?.components]);

    useEffect(() => {
        const activeStep = flow?.steps?.find(step => step.id === activeStepId) || null;
        if (!activeStep) return;

        const datalayer = {
            ...datalayerData,
            page_event: activeStep.last ? 'purchase_data' : 'form_data',
            page_type: activeStep.last ? 'purchase' : 'form',
            form_step: activeStep.last ? 'voltooid' : `${activeStep?.position}`,
            form_id: `flow-${flow?.flowId}`,
            event: activeStep.last ? 'purchase' : 'form',
        }

        if (interestComponentIds.current.length > 0) {
            const interests = interestComponentIds.current
                .flatMap(id => {
                    const stateValue = flow?.state?.[`${id}-value`];
                    return Array.isArray(stateValue) ? stateValue : [];
                });

            datalayer.form_interests = interests.map(interest => ({ interest_type: interest }));
            datalayer.form_interest_count = interests.length;
        }

        if (activeStep.last) {
            Object.assign(datalayer, {
                client_email: flow.summary.dataLayer.email ? flow.summary.dataLayer.email : 'null',
            });

            // Only the ALMN summaries carry a phone number, so this key stays absent for De Waal.
            if (flow.summary.dataLayer.phoneNumber) {
                datalayer.client_phonenumber = flow.summary.dataLayer.phoneNumber;
            }
        }

        Object.assign(datalayer, {
            'form_vp': `${datalayer.page_type}/${datalayer.form_category}/${datalayer.form_name}/${datalayer.form_step}`
        });
        pushDatalayer(datalayer);
    }, [activeStepId]);

    return null;
}
